import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "page settings-page" }
const _hoisted_2 = { class: "settings-nav" }
const _hoisted_3 = {
  key: 0,
  class: "notice"
}
const _hoisted_4 = {
  key: 1,
  class: "settings-section panel"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "connection-list" }
const _hoisted_8 = { class: "connection-main" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "connection-actions" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "connection-brands"
}
const _hoisted_18 = ["onSubmit"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = {
  key: 0,
  class: "brand-empty"
}
const _hoisted_22 = ["onSubmit"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 2,
  class: "settings-section panel"
}
const _hoisted_27 = ["onUpdate:modelValue", "onChange"]
const _hoisted_28 = {
  key: 3,
  class: "settings-section panel"
}
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = {
  key: 4,
  class: "settings-section panel ai-settings-section"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "chat-error"
}
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "ai-model-picker" }
const _hoisted_35 = {
  ref: "modelPicker",
  class: "model-combobox"
}
const _hoisted_36 = ["disabled", "aria-expanded"]
const _hoisted_37 = {
  key: 0,
  class: "model-combobox-menu"
}
const _hoisted_38 = {
  class: "model-combobox-options",
  role: "listbox"
}
const _hoisted_39 = ["aria-selected", "onClick"]
const _hoisted_40 = {
  key: 0,
  class: "model-combobox-empty"
}
const _hoisted_41 = { class: "ai-model-hint" }
const _hoisted_42 = {
  key: 6,
  class: "settings-section panel"
}
const _hoisted_43 = { class: "directory-grid" }
const _hoisted_44 = ["onUpdate:modelValue", "onChange"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "page-heading" }, [
      _createElementVNode("div", null, [
        _createElementVNode("small", null, "Администрирование"),
        _createElementVNode("h1", null, "Настройки")
      ])
    ], -1 /* CACHED */)),
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.sections, (item) => {
        return _createVNode(_component_RouterLink, {
          key: item.id,
          to: `/settings/${item.id}`,
          class: _normalizeClass({active:$setup.section===item.id})
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"])
      }), 64 /* STABLE_FRAGMENT */))
    ]),
    ($setup.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.message), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.section==='integrations')
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("header", null, [
            _cache[21] || (_cache[21] = _createElementVNode("div", null, [
              _createElementVNode("h2", null, "Интеграции"),
              _createElementVNode("p", null, "Подключения к партнёрским программам и ручной запуск импорта.")
            ], -1 /* CACHED */)),
            _createElementVNode("button", {
              class: "primary",
              onClick: $setup.toggleConnectionForm
            }, _toDisplayString($setup.showConnectionForm ? "Закрыть форму" : "+ Подключение"), 1 /* TEXT */)
          ]),
          ($setup.showConnectionForm)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "form settings-create-form",
                onSubmit: _withModifiers($setup.saveConnection, ["prevent"])
              }, [
                _createElementVNode("label", null, [
                  _cache[23] || (_cache[23] = _createTextVNode("Провайдер", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.connectionForm.provider) = $event))
                  }, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("option", { value: "affilka" }, "Affilka", -1 /* CACHED */),
                    _createElementVNode("option", { value: "referon" }, "ReferOn", -1 /* CACHED */)
                  ]))], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.connectionForm.provider]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[24] || (_cache[24] = _createTextVNode("Название", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.connectionForm.name) = $event)),
                    required: ""
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.connectionForm.name]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[25] || (_cache[25] = _createTextVNode("Base URL", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.connectionForm.base_url) = $event)),
                    placeholder: "https://partners.example.com",
                    required: ""
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.connectionForm.base_url]
                  ])
                ]),
                ($setup.connectionForm.provider==='affilka')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
                      _cache[26] || (_cache[26] = _createTextVNode("API token", -1 /* CACHED */)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.connectionForm.api_token) = $event)),
                        type: "password",
                        required: ""
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.connectionForm.api_token]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("label", null, [
                        _cache[27] || (_cache[27] = _createTextVNode("Логин ReferOn", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.connectionForm.referon_username) = $event)),
                          autocomplete: "username",
                          required: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.connectionForm.referon_username]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[28] || (_cache[28] = _createTextVNode("Пароль ReferOn", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.connectionForm.referon_password) = $event)),
                          type: "password",
                          autocomplete: "new-password",
                          required: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.connectionForm.referon_password]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[29] || (_cache[29] = _createTextVNode("TOTP secret", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.connectionForm.referon_totp_secret) = $event)),
                          type: "password",
                          autocomplete: "off",
                          required: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.connectionForm.referon_totp_secret]
                        ])
                      ])
                    ], 64 /* STABLE_FRAGMENT */)),
                _createElementVNode("label", null, [
                  _cache[30] || (_cache[30] = _createTextVNode("Валюта", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.connectionForm.conversion_currency) = $event)),
                    disabled: ""
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.connectionForm.conversion_currency]
                  ])
                ]),
                _createElementVNode("button", {
                  class: "primary",
                  disabled: $setup.savingConnection
                }, _toDisplayString($setup.savingConnection ? "Сохранение…" : "Добавить подключение"), 9 /* TEXT, PROPS */, _hoisted_6)
              ], 32 /* NEED_HYDRATION */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.connections, (connection) => {
              return (_openBlock(), _createElementBlock("article", {
                key: connection.id,
                class: "connection-card"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("strong", null, _toDisplayString(connection.name), 1 /* TEXT */),
                  _createElementVNode("small", null, _toDisplayString(connection.provider === 'referon' ? `ReferOn · ${connection.referon_username}` : 'Affilka') + " · " + _toDisplayString(connection.base_url), 1 /* TEXT */),
                  (connection.provider === 'referon' && connection.last_referon_session_at)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_9, "Сессия обновлена: " + _toDisplayString(connection.last_referon_session_at), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["status", connection.active ? 'succeeded' : 'failed'])
                }, _toDisplayString(connection.active ? "Активно" : "Выключено"), 3 /* TEXT, CLASS */),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: $event => ($setup.testConnection(connection.id))
                  }, "Проверить", 8 /* PROPS */, _hoisted_11),
                  _createElementVNode("button", {
                    disabled: !connection.active,
                    onClick: $event => ($setup.importPartners(connection.id))
                  }, "Импорт партнёров", 8 /* PROPS */, _hoisted_12),
                  _createElementVNode("button", {
                    disabled: !connection.active,
                    onClick: $event => ($setup.importStatsToday(connection.id))
                  }, "Статистика за сегодня", 8 /* PROPS */, _hoisted_13),
                  (connection.provider === 'affilka')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: !connection.active,
                        onClick: $event => ($setup.importTrafficToday(connection.id))
                      }, "Трафик за сегодня", 8 /* PROPS */, _hoisted_14))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    onClick: $event => ($setup.toggleBrands(connection))
                  }, "Бренды (" + _toDisplayString(connection.brands.length) + ")", 9 /* TEXT, PROPS */, _hoisted_15),
                  _createElementVNode("button", {
                    class: _normalizeClass({danger:connection.active}),
                    onClick: $event => ($setup.toggleConnection(connection))
                  }, _toDisplayString(connection.active ? "Отключить" : "Включить"), 11 /* TEXT, CLASS, PROPS */, _hoisted_16)
                ]),
                ($setup.brandEditorId===connection.id)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                      _cache[33] || (_cache[33] = _createElementVNode("header", null, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, "Справочник брендов"),
                          _createElementVNode("small", null, "Внешний ID будет заменён этим названием в отчётах.")
                        ])
                      ], -1 /* CACHED */)),
                      _createElementVNode("form", {
                        class: "brand-create-form",
                        onSubmit: _withModifiers($event => ($setup.createBrand(connection)), ["prevent"])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": $event => (($setup.brandForms[connection.id].external_id) = $event),
                          required: "",
                          placeholder: "ID бренда"
                        }, null, 8 /* PROPS */, _hoisted_19), [
                          [_vModelText, $setup.brandForms[connection.id].external_id]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": $event => (($setup.brandForms[connection.id].name) = $event),
                          required: "",
                          placeholder: "Название бренда"
                        }, null, 8 /* PROPS */, _hoisted_20), [
                          [_vModelText, $setup.brandForms[connection.id].name]
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("button", { class: "primary" }, "Добавить", -1 /* CACHED */))
                      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_18),
                      (!connection.brands.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Соответствий пока нет"))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connection.brands, (brand) => {
                        return (_openBlock(), _createElementBlock("form", {
                          key: brand.id,
                          class: "brand-directory-row",
                          onSubmit: _withModifiers($event => ($setup.saveBrand(connection,brand)), ["prevent"])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": $event => ((brand.external_id) = $event),
                            required: "",
                            "aria-label": "ID бренда"
                          }, null, 8 /* PROPS */, _hoisted_23), [
                            [_vModelText, brand.external_id]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": $event => ((brand.name) = $event),
                            required: "",
                            "aria-label": "Название бренда"
                          }, null, 8 /* PROPS */, _hoisted_24), [
                            [_vModelText, brand.name]
                          ]),
                          _cache[32] || (_cache[32] = _createElementVNode("button", null, "Сохранить", -1 /* CACHED */)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "danger",
                            onClick: $event => ($setup.deleteBrand(connection,brand))
                          }, "Удалить", 8 /* PROPS */, _hoisted_25)
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_22))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : ($setup.section==='users')
        ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
            _createElementVNode("header", null, [
              _cache[34] || (_cache[34] = _createElementVNode("div", null, [
                _createElementVNode("h2", null, "Пользователи"),
                _createElementVNode("p", null, "Менеджеры, роли и чаты для персональных уведомлений.")
              ], -1 /* CACHED */)),
              _createElementVNode("button", {
                class: "primary",
                onClick: _cache[8] || (_cache[8] = $event => ($setup.showUserForm=!$setup.showUserForm))
              }, _toDisplayString($setup.showUserForm ? "Закрыть форму" : "+ Пользователь"), 1 /* TEXT */)
            ]),
            ($setup.showUserForm)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "form settings-create-form",
                  onSubmit: _withModifiers($setup.createUser, ["prevent"])
                }, [
                  _createElementVNode("label", null, [
                    _cache[35] || (_cache[35] = _createTextVNode("Имя", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.userForm.name) = $event)),
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.userForm.name]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[36] || (_cache[36] = _createTextVNode("Email", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.userForm.email_address) = $event)),
                      type: "email",
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.userForm.email_address]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[37] || (_cache[37] = _createTextVNode("Telegram chat ID", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.userForm.telegram_user_id) = $event)),
                      placeholder: "Можно заполнить позже"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.userForm.telegram_user_id]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[39] || (_cache[39] = _createTextVNode("Роль", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.userForm.role) = $event))
                    }, [...(_cache[38] || (_cache[38] = [
                      _createElementVNode("option", { value: "manager" }, "Менеджер", -1 /* CACHED */),
                      _createElementVNode("option", { value: "admin" }, "Администратор", -1 /* CACHED */)
                    ]))], 512 /* NEED_PATCH */), [
                      [_vModelSelect, $setup.userForm.role]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[40] || (_cache[40] = _createTextVNode("Пароль", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($setup.userForm.password) = $event)),
                      type: "password",
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.userForm.password]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[41] || (_cache[41] = _createTextVNode("Повтор пароля", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.userForm.password_confirmation) = $event)),
                      type: "password",
                      required: ""
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.userForm.password_confirmation]
                    ])
                  ]),
                  _cache[42] || (_cache[42] = _createElementVNode("button", { class: "primary" }, "Создать пользователя", -1 /* CACHED */))
                ], 32 /* NEED_HYDRATION */))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                key: user.id,
                class: "dictionary-row user-telegram-row"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(user.name), 1 /* TEXT */),
                  _createElementVNode("small", null, _toDisplayString(user.role === 'admin' ? 'Администратор' : 'Менеджер') + " · " + _toDisplayString(user.email_address), 1 /* TEXT */)
                ]),
                _createElementVNode("label", null, [
                  _cache[43] || (_cache[43] = _createTextVNode("Telegram chat ID", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": $event => ((user.telegram_user_id) = $event),
                    placeholder: "Например, 123456789",
                    onChange: $event => ($setup.saveUserTelegram(user))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_27), [
                    [_vModelText, user.telegram_user_id]
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : ($setup.section==='telegram')
          ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
              _cache[48] || (_cache[48] = _createElementVNode("header", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", null, "Telegram"),
                  _createElementVNode("p", null, "Бот, административный чат и публичный адрес CRM.")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("form", {
                class: "form settings-create-form",
                onSubmit: _withModifiers($setup.saveTelegram, ["prevent"])
              }, [
                _createElementVNode("label", null, [
                  _cache[44] || (_cache[44] = _createTextVNode("Bot token", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.telegram.bot_token) = $event)),
                    type: "password",
                    placeholder: $setup.telegram.token_configured ? 'Токен уже настроен' : ''
                  }, null, 8 /* PROPS */, _hoisted_29), [
                    [_vModelText, $setup.telegram.bot_token]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[45] || (_cache[45] = _createTextVNode("ID административного чата", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.telegram.admin_chat_id) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.telegram.admin_chat_id]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _cache[46] || (_cache[46] = _createTextVNode("Публичный URL CRM", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($setup.telegram.public_url) = $event)),
                    placeholder: "https://crm.example.com"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.telegram.public_url]
                  ])
                ]),
                _cache[47] || (_cache[47] = _createElementVNode("button", { class: "primary" }, "Сохранить Telegram", -1 /* CACHED */))
              ], 32 /* NEED_HYDRATION */)
            ]))
          : ($setup.section==='ai')
            ? (_openBlock(), _createElementBlock("section", _hoisted_30, [
                _createElementVNode("header", null, [
                  _cache[49] || (_cache[49] = _createElementVNode("div", null, [
                    _createElementVNode("h2", null, "AI и модели"),
                    _createElementVNode("p", null, "Доступ к OpenRouter и модель, которая будет использоваться в новых чатах.")
                  ], -1 /* CACHED */)),
                  _createElementVNode("button", {
                    disabled: !$setup.aiSettings.openrouter_key_configured || $setup.modelsLoading,
                    onClick: $setup.loadModels
                  }, _toDisplayString($setup.modelsLoading ? "Загрузка…" : "Обновить модели"), 9 /* TEXT, PROPS */, _hoisted_31)
                ]),
                ($setup.aiError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($setup.aiError), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("form", {
                  class: "form settings-create-form ai-settings-form",
                  onSubmit: _withModifiers($setup.saveAi, ["prevent"])
                }, [
                  _createElementVNode("label", null, [
                    _cache[50] || (_cache[50] = _createTextVNode("OpenRouter API key", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($setup.aiSettings.openrouter_api_key) = $event)),
                      type: "password",
                      autocomplete: "off",
                      placeholder: $setup.aiSettings.openrouter_key_configured ? 'Ключ уже настроен — оставьте пустым, чтобы не менять' : 'sk-or-v1-…'
                    }, null, 8 /* PROPS */, _hoisted_33), [
                      [_vModelText, $setup.aiSettings.openrouter_api_key]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_34, [
                    _cache[52] || (_cache[52] = _createTextVNode("Рабочая модель", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "model-combobox-trigger",
                        disabled: $setup.modelsLoading || !$setup.models.length,
                        "aria-expanded": $setup.modelMenuOpen,
                        "aria-haspopup": "listbox",
                        onClick: $setup.toggleModelMenu
                      }, [
                        _createElementVNode("span", null, _toDisplayString($setup.selectedModel ? `${$setup.selectedModel.name} · ${$setup.selectedModel.id}` : ($setup.modelsLoading ? "Загрузка моделей…" : "Выберите модель")), 1 /* TEXT */),
                        _cache[51] || (_cache[51] = _createElementVNode("span", { "aria-hidden": "true" }, "⌄", -1 /* CACHED */))
                      ], 8 /* PROPS */, _hoisted_36),
                      ($setup.modelMenuOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("input", {
                              ref: "modelSearchInput",
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($setup.modelSearch) = $event)),
                              type: "search",
                              placeholder: "Поиск по названию или slug…",
                              "aria-label": "Поиск модели",
                              onKeydown: _cache[20] || (_cache[20] = _withKeys($event => ($setup.modelMenuOpen=false), ["esc"]))
                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                              [_vModelText, $setup.modelSearch]
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredModels, (model) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: model.id,
                                  type: "button",
                                  role: "option",
                                  "aria-selected": model.id === $setup.aiSettings.working_model,
                                  class: _normalizeClass({selected:model.id === $setup.aiSettings.working_model}),
                                  onClick: $event => ($setup.selectModel(model.id))
                                }, [
                                  _createElementVNode("strong", null, _toDisplayString(model.name), 1 /* TEXT */),
                                  _createElementVNode("small", null, _toDisplayString(model.id), 1 /* TEXT */)
                                ], 10 /* CLASS, PROPS */, _hoisted_39))
                              }), 128 /* KEYED_FRAGMENT */)),
                              (!$setup.filteredModels.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Модели не найдены"))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 512 /* NEED_PATCH */)
                  ]),
                  _createElementVNode("small", _hoisted_41, "Показываются текстовые модели OpenRouter с поддержкой tool calling. Загружено: " + _toDisplayString($setup.models.length) + ".", 1 /* TEXT */),
                  _cache[53] || (_cache[53] = _createElementVNode("button", { class: "primary" }, "Сохранить AI", -1 /* CACHED */))
                ], 32 /* NEED_HYDRATION */)
              ]))
            : ($setup.section==='alerts')
              ? (_openBlock(), _createBlock($setup["AlertSettings"], {
                  key: 5,
                  class: "settings-alert-page"
                }))
              : (_openBlock(), _createElementBlock("section", _hoisted_42, [
                  _cache[57] || (_cache[57] = _createElementVNode("header", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", null, "Справочники"),
                      _createElementVNode("p", null, "Стадии задач и приоритеты категорий партнёров.")
                    ])
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", null, [
                      _cache[54] || (_cache[54] = _createElementVNode("h3", null, "Стадии", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: stage.id,
                          class: "dictionary-row"
                        }, [
                          _createElementVNode("span", {
                            class: "stage-dot",
                            style: _normalizeStyle({ background: stage.color })
                          }, null, 4 /* STYLE */),
                          _createElementVNode("strong", null, _toDisplayString(stage.name), 1 /* TEXT */),
                          _createElementVNode("small", null, _toDisplayString(stage.kind === 'partner' ? 'Партнёры' : 'Задачи'), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("div", null, [
                      _cache[56] || (_cache[56] = _createElementVNode("h3", null, "Категории партнёров", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categories, (category) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: category.id,
                          class: "dictionary-row category-priority-row"
                        }, [
                          _createElementVNode("span", {
                            class: "stage-dot",
                            style: _normalizeStyle({ background: category.color })
                          }, null, 4 /* STYLE */),
                          _createElementVNode("strong", null, _toDisplayString(category.name), 1 /* TEXT */),
                          _createElementVNode("label", null, [
                            _cache[55] || (_cache[55] = _createTextVNode("Приоритет", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": $event => ((category.priority) = $event),
                              type: "number",
                              onChange: $event => ($setup.saveCategory(category))
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_44), [
                              [
                                _vModelText,
                                category.priority,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
  ]))
}